import React from "react";
import { CourseValidationErrors } from "@src/components/libraryItemDetailPages/course/types/validation";

import { ViewingMode } from "../../shared/CourseOutlineCenterContentWrapper";
import { SkillValidationErrors } from "@builder/skill/utils/validation";
import { ContentQrCodeFragment } from "@src/fragments.generated";

export type PathBuilderContextState = {
  skillValidationErrors: SkillValidationErrors;
  activeMembershipUuid: string | undefined;
  setActiveMembershipUuid: (itemId: string) => void;
  viewingMode: ViewingMode;
  setViewingMode: (viewingMode: ViewingMode) => void;
  onSelectHomeScreen: () => void;
  isHomeScreenSelected: boolean;
  setIsHomeScreenSelected: (isHomeScreenSelected: boolean) => void;
  marketplacePath: boolean;
  aiModuleGenerating: boolean;
  aiSCORMUploading: boolean;
  aiSCORMError: boolean;
  moduleQRCode: ContentQrCodeFragment | null | undefined;
  setModuleQrCode: (qrCode: ContentQrCodeFragment) => void;
};
export const PathBuilderContext = React.createContext<
  PathBuilderContextState | undefined
>(undefined);

export type PathValidationErrors = {
  courseIdToValidationErrors: Map<number, CourseValidationErrors>;
  skillIdToValidationErrors: Map<number, SkillValidationErrors>;
  duplicateMembershipUuids: Set<string>;
  courseOutlineIds: Array<string>;
  emptySectionBreakUuids: Set<string>;
};
